import { Injectable, inject } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { Roles } from '../enums/roles';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard {
  private authService = inject(AuthService);
  private router = inject(Router);


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authService.currentUserValue;
    const requiredAccessLevel = route.data['role'];
    if (currentUser && requiredAccessLevel.includes(currentUser.role)) {
      return true;
    } else {
      this.router.navigate(['/case-table']);
      return false;
    }
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authService.currentUserValue;

    if (currentUser && currentUser.role !== Roles.Guest) {
      return true;
    } else {
      this.router.navigate(['/auth/login']);
      return false;
    }
  }
}
